/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-print-xl': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M12.281.767a.5.5 0 0 1 .385.18l1.48 1.786H17.5a2.5 2.5 0 0 1 2.495 2.336l.005.164v6a2.5 2.5 0 0 1-2.5 2.5h-2v5a.5.5 0 0 1-.41.492l-.09.008H5a.5.5 0 0 1-.492-.41l-.008-.09v-5h-2a2.5 2.5 0 0 1-2.495-2.335L0 11.233v-6a2.5 2.5 0 0 1 2.5-2.5h2.718V1.267a.5.5 0 0 1 .41-.492l.09-.008zM14.5 13.733h-9v4.5h9v-4.5zM12 15.676a.5.5 0 0 1 .09.992l-.09.008H8a.5.5 0 0 1-.09-.991l.09-.009h4zm2.781-11.944v2.5L16 6.234a.5.5 0 0 1 .09.992l-.09.008H4a.5.5 0 0 1-.09-.992L4 6.233h1.218v-2.5H2.5A1.5 1.5 0 0 0 1.007 5.09L1 5.233v6a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5l-2.719-.001zm-2.735-1.965H6.218v4.455l7.563.003V3.859l-1.735-2.092z" _fill="#0D204A" fill-rule="evenodd"/>'
  }
})
